import { outcome_w } from 'src/backend-codes'
import { opt, redux_store } from 'src/types'

export const select_outcome_quotedoc = (state: redux_store): opt<string> =>
  state?.outcomes?.quotedoc

export const select_outcome_support_agency = (state: redux_store): opt<outcome_w> =>
  state?.outcomes?.support_agency
